import React, { Component } from 'react';
import img from '../../../assets/Admin/Invoice Adjustment/2805a44f849d578506544caae12f3297_html_5524891002f0d477.png';
import img1 from '../../../assets/Admin/Invoice Adjustment/2805a44f849d578506544caae12f3297_html_d193902d554f2b7e.png';
import img2 from '../../../assets/Admin/Invoice Adjustment/2805a44f849d578506544caae12f3297_html_fbf8a0a6c0a5c8be.png';
class InvoiceAdj extends Component {
    render() {
        return (
            <div className="mi_main">
                <p ><b > Invoice Adjustment:</b></p>
                <p>As a admin, he can adjust the invoice for adjustment . Adjustment can be done on paid invoices, adjusted invoices are paid in next month invoice.</p>
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img1} />
                <p>Get the Invoice require for adjustment.</p>
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img2} />
                <p>Adding Adjustment record to invoice.</p>
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img} />
            </div>
        )
    }
}
export default InvoiceAdj;
